import {ClockIcon} from '@heroicons/react/24/outline';
import React, {ReactElement, useMemo} from 'react';

import Col from '../../common/Col';
import Row from '../../common/Row';
import ProgressBar from './ProgressBar';

type TimelineProps = {
  currentYear: number;
  totalYears: number;
  id?: string;
};

const Timeline = ({currentYear, totalYears, id}: TimelineProps): ReactElement => {
  // Constrain year to [0, totalYears]
  const year = useMemo(() => {
    if (!currentYear) return 0;
    if (currentYear <= 0) return 0;
    if (currentYear >= totalYears) return totalYears;
    return currentYear;
  }, [currentYear, totalYears]);

  const pillOffset = useMemo(() => (year / totalYears) * 100, [year, totalYears]);
  return (
    <div className="relative mt-2 mb-8" id={id}>
      <ProgressBar progress={year / totalYears} />
      <div
        className={`absolute border-normal font-sans rounded-full py-1.5 pl-5 pr-7 -mt-12 w-fit text-md border-gray-100 bg-white text-primary-700 shadow-solid-light-green transition-horizontal duration-1000`}
        style={{left: `${pillOffset}%`, transform: `translateX(-${pillOffset}%)`}}
      >
        <Row className="space-x-2 justify-between items-center text-center">
          <Col>
            <ClockIcon className="h-7 w-7" />
          </Col>
          <Col className="whitespace-nowrap">Year {year}</Col>
        </Row>
      </div>
    </div>
  );
};

export default Timeline;
